import { getAuth } from 'firebase/auth'
const axios = require('axios')
const dev = require('./../dev')

const HttpHandler = {
  region: 'europe-west1',
  baseURL:
    'https://europe-west1-equardian.cloudfunctions.net/',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  timeout: 60000,
}

if (dev.dev) {
  HttpHandler.baseURL = 'http://localhost:5000/equardian/europe-west1/'
}

HttpHandler.get = async args => {
  if (typeof args === 'string') {
    let url = args
    args = { url }
  }

  args.method = 'get'

  return (await HttpHandler.request(args)).data
}

HttpHandler.post = async args => {
  if (typeof args === 'string') {
    let url = args
    args = { url }
  }
  args.method = 'post'
  args.data = args.body || args.data || ''

  return (await HttpHandler.request(args)).data
}

HttpHandler.request = async args => {
  args.baseURL = args.baseURL || HttpHandler.baseURL

  args.url = args.url || HttpHandler.baseURL
  args.headers = args.headers || HttpHandler.headers
  args.timeout = args.timeout || HttpHandler.timeout
  args.data = args.data || ''

  const currentUser = getAuth().currentUser

  if (args.requireLogin && currentUser) {
    const token = await currentUser.getIdToken(true)

    args.headers['Authorization'] = `Bearer ${token}`
  }

  return axios(args)
}

export default HttpHandler
